export default "__VITE_ASSET__C5afaJRa__"